import styles from "./TechLogoRow.module.scss";
import { filteredLogos } from "shared/data/portfolioData";

const TechLogos = () => {
  const duplicatedLogos = [...filteredLogos, ...filteredLogos];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.scroller}>
          {duplicatedLogos.map((logo, index) => (
            <div key={`${logo.name}-${index}`} className={styles.item}>
              <img src={logo.src} alt={logo.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechLogos;
